module.exports = __webpack_public_path__ + "static/media/DFLiKingHei.cb0d64cd.svg";